import { render, staticRenderFns } from "./SingleObjectAutocomplete.vue?vue&type=template&id=0be0aec9&scoped=true&"
import script from "./SingleObjectAutocomplete.vue?vue&type=script&lang=js&"
export * from "./SingleObjectAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be0aec9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VRow})
